/**
 * @generated SignedSource<<a9af7504f53cbf06856da786f71b5331>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OpsReservationNewPageCustomersQuery$variables = {
  search?: string | null | undefined;
};
export type OpsReservationNewPageCustomersQuery$data = {
  readonly customers: {
    readonly nodes: ReadonlyArray<{
      readonly email: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly phone: string | null | undefined;
    } | null | undefined> | null | undefined;
  };
};
export type OpsReservationNewPageCustomersQuery = {
  response: OpsReservationNewPageCustomersQuery$data;
  variables: OpsReservationNewPageCustomersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 20
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "CustomerConnection",
    "kind": "LinkedField",
    "name": "customers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsReservationNewPageCustomersQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsReservationNewPageCustomersQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9619ef914a237890901fd1053e61c40d",
    "id": null,
    "metadata": {},
    "name": "OpsReservationNewPageCustomersQuery",
    "operationKind": "query",
    "text": "query OpsReservationNewPageCustomersQuery(\n  $search: String\n) {\n  customers(search: $search, first: 20) {\n    nodes {\n      id\n      name\n      email\n      phone\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1fd0d75f196dab795880d144e399aef1";

export default node;
